import React, { useContext, useEffect } from 'react';
import { Result } from 'src/antd';
import { T } from '@transifex/react';
import { useParams } from 'react-router-dom';

import {
  useRouting,
  useHistory,
} from '../../../../routing/child-router-factory';
import { PropertyContext } from '../../../../context/property-context';

const ServiceTypeRedirect = () => {
  const { ticketTypes } = useContext(PropertyContext);
  const history = useHistory();
  const { serviceType } = useParams<{ serviceType: string }>();
  const { routingMap } = useRouting();

  const ticketTypesForThisService = ticketTypes?.find(
    ({ service }: $TSFixMe) => service?.service_type === serviceType
  ) as $TSFixMe;
  const invalid = !ticketTypesForThisService;

  useEffect(() => {
    if (ticketTypesForThisService) {
      history.replace({
        pathname: routingMap.app.selfService['create/:ticketTypeId'](
          ticketTypesForThisService?.id
        )._,
        state: history.location.state, // forwarding the state.
      });
    }
  }, [history, routingMap.app.selfService, ticketTypesForThisService]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {invalid && (
        <Result
          status="404"
          title={
            <T
              _str="Service type: {serviceType} not supported"
              serviceType={serviceType}
            />
          }
        />
      )}
    </div>
  );
};

export default ServiceTypeRedirect;
